import { render, staticRenderFns } from "./DormitoryMonitor.vue?vue&type=template&id=087d0433&scoped=true&"
import script from "./DormitoryMonitor.vue?vue&type=script&lang=js&"
export * from "./DormitoryMonitor.vue?vue&type=script&lang=js&"
import style0 from "./DormitoryMonitor.vue?vue&type=style&index=0&id=087d0433&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087d0433",
  null
  
)

export default component.exports